import SignupForm from "./SignupForm";

export default function SignupStudent() {
  return <SignupForm role="student" />;
}
